<script lang="ts">
	type HEX = string

	const durationUnitRegex = /[a-zA-Z]/

	export const calculateRgba = (color: HEX, opacity: number): string => {
		if (color[0] === '#') {
			color = color.slice(1)
		}

		if (color.length === 3) {
			let res = ''
			color.split('').forEach((c: string) => {
				res += c
				res += c
			})
			color = res
		}

		const rgbValues = (color.match(/.{2}/g) || []).map((hex: HEX) => parseInt(hex, 16)).join(', ')

		return `rgba(${rgbValues}, ${opacity})`
	}

	const range = (size: number, startAt = 0) => [...Array(size).keys()].map((i) => i + startAt)

	type SpinnerTypes = {
		size: string | number
		color: string
		unit: string
		duration: string
		pause: boolean
	}

	interface Props {
		color?: SpinnerTypes['color']
		unit?: SpinnerTypes['unit']
		duration?: SpinnerTypes['duration']
		size?: SpinnerTypes['size']
		pause?: SpinnerTypes['pause']
	}

	let {
		color = '#007acc',
		unit = 'px',
		duration = '2s',
		size = '60',
		pause = false
	}: Props = $props()

	let durationUnit: string = duration.match(durationUnitRegex)?.[0] ?? 's'
	let durationNum: string = duration.replace(durationUnitRegex, '')
</script>

<div class="wrapper" style="--size: {size}{unit}; --color: {color}; --duration: {duration};">
	<div class="spinner" class:pause-animation={pause}>
		{#each range(2, 0) as version}
			<div
				class="dot"
				class:pause-animation={pause}
				style="animation-delay: {version === 1
					? `${+durationNum / 2}${durationUnit}`
					: '0s'}; {version === 1 ? 'bottom: 0;' : ''} {version === 1 ? 'top: auto;' : ''}"
			></div>
		{/each}
	</div>
</div>

<style>
	.wrapper {
		height: var(--size);
		width: var(--size);
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.spinner {
		height: var(--size);
		width: var(--size);
		animation: rotate var(--duration) infinite linear;
	}
	.dot {
		width: 60%;
		height: 60%;
		display: inline-block;
		position: absolute;
		top: 0;
		background-color: var(--color);
		border-radius: 100%;
		animation: bounce var(--duration) infinite ease-in-out;
	}
	.pause-animation {
		animation-play-state: paused;
	}

	@keyframes rotate {
		100% {
			transform: rotate(360deg);
		}
	}
	@keyframes bounce {
		0%,
		100% {
			transform: scale(0);
		}
		50% {
			transform: scale(1);
		}
	}
</style>
